<!-- <app-header></app-header> -->
<router-outlet></router-outlet>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<div id="attractions" class="container my-5">
  <div class="row">
    <!-- Left Side -->
    <div class="col-md-5 col-12 mb-4 d-flex align-items-center justify-content-center flex-column text-center">
      <h1 class="explore-heading">EXPLORE</h1>
      <h1 class="explore-subheading">THE CITY</h1>
      <p class="description">
        Our knowledgeable concierge team can assist you in planning your itinerary and arranging tours, tickets, and
        transportation.
      </p>
      <a (click)="scrollToSection('location')" class="contact-button btn btn-primary">Contact Us</a>
    </div>

    <!-- Right Side (Grid of Images) -->
    <!-- {{this.token?.getProperty()?.address?.city}} -->
    <div class="col-md-7 col-12">
      <main *ngIf="blogPosts$ | async as blogPosts">
        <div *ngFor="let blogPost of blogPosts.items; let i = index">
          <div class="row">
            <ng-container *ngFor="let item of blogPost.fields.citiesimages; let j = index">
              <div class="col-md-6 col-12 mb-4"
                *ngIf="j < 4 && blogPost.fields.title === this.tokenStorage?.getProperty()?.address?.city">

                <div *ngIf="blogPost.fields.title === this.tokenStorage?.getProperty()?.address?.city ">

                  <div class="card" style="z-index: 1; margin-bottom: -40px; border-radius: 15px;">
                    <img [src]="item.fields.file.url" class="card-img-top" style="border-radius: 15px;height:200px"
                      alt="This Temple">
                  </div>
                  <div class="card-body text-center card-body-style"
                    style="background-color: var(--primary) !important; margin-left: -10px; margin-right: -10px; border-radius: 10px; padding-top: 50px;">
                    <h5 class="card-title">{{ item.fields.title }}</h5>
                  </div>

                </div>

              </div>
            </ng-container>
          </div>

        </div>
      </main>
    </div>


  </div>
</div>

<div class="nearby-places-section">
  <h2 class="section-heading">Nearby Places</h2>
  <div class="unique-cards-container d-none d-md-flex">
    <div class="card unique-card">
      <img src="assets/images/water park.jpg" class="card-img-top" alt="Water Park">
      <div class="card-body">
        <p class="card-text">Water Park</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Theme Park.jpg" class="card-img-top" alt="Theme Park">
      <div class="card-body">
        <p class="card-text">Theme Park</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Khandoba Temple.jpg" class="card-img-top" alt="Khandoba Temple">
      <div class="card-body">
        <p class="card-text">Khandoba Temple</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Panchmukhi Ganesh Temple.jpg" class="card-img-top" alt="Panchmukhi Ganesh Temple">
      <div class="card-body">
        <p class="card-text">Panchmukhi Ganesh Temple</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Baba Ka Chawri.jpg" class="card-img-top" alt="Baba Ka Chawri">
      <div class="card-body">
        <p class="card-text">Baba Ka Chawri</p>
      </div>
    </div>
  </div>
</div>




<div class="unique-carousel-wrapper d-block d-md-none">
  <h2 class="section-heading">Nearby Places</h2>
  <div class="unique-carousel-card shadow-lg border-0 rounded overflow-hidden">
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
      <div class="carousel-inner unique-carousel-inner">
        <!-- Loop through the items using Angular's *ngFor -->
        <div *ngFor="let item of carouselItems; let i = index" class="carousel-item" [ngClass]="{ 'active': i === 0 }">
          <div class="unique-carousel-item-content text-center p-3">
            <div class="unique-carousel-item-card">
              <img [src]="item.imgSrc" [alt]="item.title" class="img-fluid circular-image">
              <h2 class="mt-3">{{ item.title }}</h2>
              <p>{{ item.age }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Carousel Controls -->
      <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</div>









<div class="container my-5">
  <div class="row" id="testimonials">
    <!-- First Column -->
    <div class="col-md-4 mb-4 d-flex flex-column justify-content-center align-items-start">
      <h2 class="headline font-weight-bold mb-3">Real Stays, Real Talk</h2>
      <p class="intro-text mb-4 text-muted">Here's what our guests are saying...</p>
      <a href="https://search.google.com/local/writereview?placeid=ChIJB5PuPSJb3DsRdJ5S-sYC0kc"
        class="btn btn-primary btn-lg writereview">
        <div style="padding-left: 10px;padding-right: 10px;">
          Write a Review
        </div>
      </a>
    </div>

    <!-- Second Column (Carousel for Desktop) -->
    <div class="col-md-8 mb-4 d-md-block">
      <div class="carousel-controls">
        <a href="#carouselExampleControlsreview" role="button" data-slide="prev" class="carousel-control-prev">
          <span aria-hidden="true" class="carousel-control-prev-icon"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a href="#carouselExampleControlsreview" role="button" data-slide="next" class="carousel-control-next">
          <span aria-hidden="true" class="carousel-control-next-icon"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
      <div class="card shadow-sm border-0 h-100">
        <div id="carouselExampleControlsreview" data-ride="carousel" class="carousel slide">
          <div class="carousel-inner style_carasol" style="display: block;">

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Ved Bhandare"
                      class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Manjushree Patil</h5>
                    <p class="small text-muted mb-2 review-text">I recently visited Shirdi for the first time and stayed
                      at Hotel Sai Ramanand. The location was perfect, with easy access to the temple. Our room had the
                      best view, and we could hear the divine Sai Aarti from the window, which made the experience even
                      more special. The room was clean, spacious, and comfortable, and the ambiance was great for
                      celebrating my birthday. The food was delicious, and room service was prompt. The staff was polite
                      and offered excellent hospitality. Overall, a wonderful stay, and I highly recommend this hotel
                      for anyone visiting Shirdi!</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Vaishali Kokane"
                      class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Ivy Chakrabarty</h5>
                    <p class="small text-muted mb-2 review-text">We had good experience in Sai Ramanand Hotel. For food
                      either one can order in the room or visit to the restaurants nearby. The food was overall good.
                      Hot water was available in the early morning. We had a nice stay there. One can try!</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item active carousel-item-left">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="DR.SACHIN NARHAR JOSHI"
                      class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Raghuveersingh Bhandari</h5>
                    <p class="small text-muted mb-2 review-text">Good place, nice rooms, very good food, almost good
                      manage by Chandu.</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item carousel-item-next carousel-item-left">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="shyam mourya"
                      class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">Darshan Tambe</h5>
                    <p class="small text-muted mb-2 review-text">I didn’t expect much from a roadside hotel, but this
                      place was fantastic. The rooms were super clean, the staff was incredibly welcoming, and I
                      specially liked their hospitality and the behaviour of staff is really appreciative . Highly
                      recommend!</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="Koustubh Mangrulkar"
                      class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">
                      Pradumna Shewale</h5>
                    <p class="small text-muted mb-2 review-text">Excellent highway side hotel . Best for family great
                      variety of menu . Good facilitated rooms and service staff was good .</p>
                    <div class="star-ratings text-warning">★★★★</div>
                  </div>
                </div>
              </div>
            </div>

            <div data-interval="10000" class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3 text-center">
                    <img src="assets/images/user-logo.png" alt="pavi rajendran"
                      class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;">
                    <h5 class="font-weight-bold mb-1">
                      Tejas Deotare</h5>
                    <p class="small text-muted mb-2 review-text">Very good hotel to stay with family…location bhi ekdum
                      road pe h aur parking b achi h car k liye</p>
                    <div class="star-ratings text-warning">★★★★★</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>





  </div>
</div>






<div id="location" style="margin-bottom: 2px;">
  <div style="position: relative; width: 100%; max-width: 100%; height: 600px;">
    <!-- The iframe -->
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d120142.60065281708!2d74.38744069917595!3d19.778242832278934!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bdc5b223dee9307%3A0x47d202c6fa529e74!2sNagar%2C%20Manmad%20Rd%2C%20near%20Vip%20Guest%20House%2C%20Shirdi%2C%20Rahata%2C%20Maharashtra%20423109!3m2!1d19.778261699999998!2d74.46984239999999!5e0!3m2!1sen!2sin!4v1726003040731!5m2!1sen!2sin"
      width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"></iframe> <!-- Overlay content -->
    <div class="card" style="position: absolute; top: 50px; text-align: center; left: 50px; background-color: white; border-bottom-left-radius: 61px;box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-top-right-radius: 59px;
    padding: 50px;">
      <h3>Make Unforgettable Memories</h3>
      <p>We're here to assist you with any questions, requests, or bookings.<br> Please don't hesitate to reach out to
        us.</p>
      <button class="book-btn" (click)="navigate()">Book Your Stay</button>
      <p class="contact-footer">
        <i class="fa fa-phone"></i> {{property?.mobile}}
      </p>
      <p class="contact-footer">
        <i class="fa fa-envelope"></i> {{property?.email}}
      </p>

    </div>

  </div>
</div>
<!-- Dialogflow Messenger Integration -->

<df-messenger project-id="impactful-name-306810" agent-id="8bb6c52c-8667-4a24-a789-4cd78b154c96" intent="WEBSITE"
  storage-option="none" language-code="en" max-query-length="-1">
  <df-messenger-chat-bubble id="chatbot" chat-subtitle=""></df-messenger-chat-bubble>
</df-messenger>
<a [href]="getWhatsappShareUrl()" class="float" target="_blank">
  <i class="fa fa-whatsapp my-float"></i>
</a>

<app-footer></app-footer>